import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_overlay = _resolveComponent("v-overlay")!

  return (_openBlock(), _createBlock(_component_v_overlay, {
    scrim: "red",
    modelValue: _ctx.showOverlay,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showOverlay) = $event))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, {
        class: "ma-auto text-center transparent",
        flat: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_progress_circular, {
            color: "primary",
            indeterminate: "",
            size: "180",
            width: "6"
          }, {
            default: _withCtx(() => [
              _createTextVNode("loading")
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}